import { datadogLogs } from "@datadog/browser-logs";
import { RedoOutboundLabelsRpcClient } from "@redotech/redo-merchant-fulfillment-rpc/client";
import { FulfillmentGroupUpdate } from "@redotech/redo-merchant-fulfillment-rpc/schema/update-fulfillment-groups";
import { toast } from "@redotech/redo-web/alert";

export async function updateFulfillmentGroupsWithAlertFailure(
  client: RedoOutboundLabelsRpcClient,
  updates: FulfillmentGroupUpdate[],
  options: { signal?: AbortSignal; teamId?: string } = {},
) {
  try {
    const result = await client.updateFulfillmentGroups(
      { updates },
      { signal: options.signal },
    );
    return result;
  } catch (error) {
    if (shouldShowError(error)) {
      datadogLogs.logger.error(
        "Showing error toast to the user for fulfillment group updates",
        { error, teamId: options.teamId },
      );
      toast("Error updating - please try again", {
        variant: "error",
        duration: Temporal.Duration.from({ seconds: 5 }),
      });
    } else {
      datadogLogs.logger.error("Error updating fulfillment groups", {
        error,
        teamId: options.teamId,
      });
    }
    throw error;
  }
}

// Consider adding more to this in the future
function shouldShowError(error: any): boolean {
  const statusCode = error?.status || error?.statusCode;
  return statusCode === 504;
}
